export function extractPtDigits(raw: string): string {
  if (!raw) return '';
  const digits = raw.replace(/\D/g, '');
  const stripped =
    digits.startsWith('351') && digits.length > 3 && digits[3] === '9'
      ? digits.slice(3)
      : digits;
  return stripped.slice(0, 9);
}

export function formatPtDigits(digits: string): string {
  const d = digits.slice(0, 9);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `${d.slice(0, 3)} ${d.slice(3)}`;
  return `${d.slice(0, 3)} ${d.slice(3, 6)} ${d.slice(6)}`;
}

export function toCanonicalPhone(digits: string): string {
  if (digits.length !== 9) return '';
  return `+351 ${digits}`;
}
